module.exports = __webpack_public_path__ + "static/media/10.1.f8286a1d.png";